/* eslint-disable eol-last */
/**
 * 字典工具类
 */
/**
  性别：gender
  民族：nation
  学历：education_bg
  专业：major
  兴趣爱好：hobby
  专业特长：speciality
  案件状态：case_status
  立案案由（法标）：case_reason
  案件类型（法标）：case_type
  简讯发布状态：publish_status
  简讯类型：news_type
  陪审员状态：juror_status
  庭审状态：trial_status
  庭审参与状态：trial_join_status
  庭审退出原因：trial_reject_reason
  消息类型：msg_type
  消息是否已读：msg_read
*/
const GROUP = {
  // 性别
  gender: { value: 'gender' },
  // 民族
  nation: { value: 'nation' },
  // 学历
  educationBg: { value: 'education_bg' },
  // 专业
  major: { value: 'major' },
  // 兴趣爱好
  hobby: { value: 'hobby' },
  // 专业特长
  speciality: { value: 'speciality' },
  // 案件状态
  caseStatus: { value: 'case_status' },
  // 立案案由(法标)
  // caseReason: { value: 'case_reason' },
  // 案件类型(法标)
  caseType: { value: 'case_type' },
  // 简讯发布状态
  publishStatus: { value: 'publish_status' },
  // 简讯类型
  newsType: { value: 'news_type' },
  // 陪审员状态
  jurorStatus: { value: 'juror_status' },
  // 庭审状态
  trialStatus: { value: 'trial_status', default: '1', NOT_START: '0', HAS_OPENED: '1', HAS_CANCELED: '2' },
  // 庭审参审状态
  // 庭审参审状态
  trialJoinStatus: {
    value: 'trial_join_status',
    WAIT_FOR_APPLY: '10',
    HAS_CANCELED: '11',
    WAIT_FOR_FEED_BACK: '20',
    HAS_CONFIRMED: '21',
    HAS_RETURNED: '22',
    HAS_JOIN: '23',
    HAS_NOT_JOIN: '24'
  },
  // 庭审退出原因
  trialRejectReason: { value: 'trial_reject_reason' },
  // 消息类型
  msgType: { value: 'msg_type' },
  // 消息是否已读
  msgRead: { value: 'msg_read' },
  // 适用程序
  sycx: { value: 'sycx' },
  // 合议观点
  talk: { value: 'talk' }
}

export default {
  GROUP: GROUP,
  getGroups () {
    return Object.keys(GROUP).map(each => GROUP[each].value).join(',')
  }
}



// WEBPACK FOOTER //
// ./src/utils/dict.js